module.exports = __webpack_public_path__ + "img/20.fb848f4a.jpg";